import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "multiple" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "sources" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_SourceTag = _resolveComponent("SourceTag")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: _normalizeClass(["option", {selected: $options.selected === idx}])
      }, [
        _createVNode(_component_Button, {
          class: "button",
          "data-test-id": idx,
          disabled: $props.disabled || $options.selected !== -1,
          primary: $options.selected === idx,
          tiny: "",
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          onClick: $event => ($options.onAccept(idx))
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Select ")
          ]))]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-test-id", "disabled", "primary", "onClick"]),
        _createElementVNode("div", {
          class: "option-content",
          disabled: $options.optionDisabled(idx)
        }, [
          _createElementVNode("div", {
            class: "title ellipsis",
            title: option.title
          }, _toDisplayString(option.title), 9 /* TEXT, PROPS */, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (option.linkedin_url)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "source pointer",
                  onClick: $event => (_ctx.$utils.openLink(option.linkedin_url))
                }, [
                  _createVNode(_component_SourceTag, {
                    size: "1.6rem",
                    logo: "assets/linkedin-square.svg",
                    class: "tag",
                    name: "View LinkedIn"
                  }),
                  _createVNode(_component_Icon, {
                    icon: "link-external-01",
                    width: "1.6rem",
                    height: "1.6rem",
                    "stroke-width": "1",
                    stroke: "#414651"
                  })
                ], 8 /* PROPS */, _hoisted_5))
              : _createCommentVNode("v-if", true),
            (option.url)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "source pointer",
                  onClick: $event => (_ctx.$utils.openLink(option.url))
                }, [
                  _createVNode(_component_SourceTag, {
                    size: "1.6rem",
                    icon: "globe-02",
                    class: "tag",
                    name: "View Website"
                  }),
                  _createVNode(_component_Icon, {
                    icon: "link-external-01",
                    width: "1.6rem",
                    height: "1.6rem",
                    "stroke-width": "1",
                    stroke: "#414651"
                  })
                ], 8 /* PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true)
          ])
        ], 8 /* PROPS */, _hoisted_2)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */)),
    ($props.skip || $props.skipAll)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "skip-block",
          disabled: $props.disabled
        }, [
          ($props.skip)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "ai-option skip",
                onClick: $options.onSkip
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Skip ")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : _createCommentVNode("v-if", true),
          ($props.skipAll)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "ai-option skip",
                onClick: $options.onSkipAll
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Skip All ")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_7))
      : _createCommentVNode("v-if", true)
  ]))
}